import { Pipe, PipeTransform } from '@angular/core';
import { DocumentationType, IDocumentation } from '../models/orders/order';

/**
 * Filters all of the Documents from an order for the specified DocumentationTypes (Invoice by default).
 * @param items The documentation objects of the order.
 * @param filterTypes The array of DocumentationType values to filter for. Defaults to [DocumentationType.Invoice].
 * @returns The items corresponding to the given DocumentationType values.
 */
@Pipe({
  name: 'documentType',
  standalone: true
})
export class DocumentTypePipe implements PipeTransform {
  /**
   * Filters all of the Documents from an order for the specified DocumentationTypes (Invoice by default).
   * @param items The documentation objects of the order.
   * @param filterTypes The array of DocumentationType values to filter for. Defaults to [DocumentationType.Invoice].
   * @returns The items corresponding to the given DocumentationType values.
   */
  transform(items: IDocumentation[], filterTypes: DocumentationType[] = [DocumentationType.Invoice]): IDocumentation[] {
    if (!Array.isArray(items)) {
      return [];
    }
    return items.filter((item) => filterTypes.includes(item.type));
  }
}
